import classNames from "classnames";
import React, { memo } from "react";

const DefinitionList = ({ children, className }: { children: (false | JSX.Element)[]; className?: string }) =>
	!!children ? <dl className={classNames("definition-list", className)}>{children}</dl> : null;

export default memo(DefinitionList);
